import React, { Component } from 'react';
import { connect } from 'react-redux';

import { receiveError } from '../../store/actions/notificationAction';

import pickupOrderRemote from '../../api/pickupOrderRemote';

import ApiResponse from '../../models/ApiResponse';
import ResponseError from '../../models/ResponseError';
import GhaPickupStatusAwb from '../../models/GhaPickupStatusAwb';
import GhaPickupStatus from '../../models/GhaPickupStatus';

import ReadyForCarriageCheck from './ReadyForCarriageCheck';
import OtherChecksModel from '../../models/OtherChecks';

import { PO_AWB_SCHEMA } from '../../utils/pickupOrder';
import { Value } from '../../models/OtherChecksForm';

interface ReadyForCarriageCheckContainerProps {
  doNumber: string;
  code: string;
  number: string;
  version: number;
  handleClose: (type: string) => void;
  receiveError: Function;
  onlyRead?: boolean
};

interface ReadyForCarriageCheckContainerState {
  poAwb: GhaPickupStatusAwb;
  flight?: string;
  statusTransportation: boolean;
  statusShipper: boolean;
  statusOther: boolean;
  statusInterline: boolean;
  doNumber: string;
  awbCode: string;
  awbNumber: string;
  deliveredDate: string;
  specialstatus: boolean;
};

class ReadyForCarriageCheckContainer extends Component<ReadyForCarriageCheckContainerProps, ReadyForCarriageCheckContainerState> {

  state = {
    poAwb: PO_AWB_SCHEMA,
    flight: '',
    statusTransportation: false,
    statusShipper: false,
    statusOther: false,
    statusInterline: false,
    doNumber: '',
    awbCode: '',
    awbNumber: '',
    deliveredDate: '',
    specialstatus: false
  };

  componentDidMount() {

    const doNumber: string = this.props.doNumber;
    const awbCode: string = this.props.code;
    const awbNumber: string = this.props.number;
    
    if (this.props.doNumber && this.props.code && this.props.number) {
      this.setState({ doNumber, awbCode, awbNumber });
      this.handleCommonResponsePoAwb(doNumber, awbCode, awbNumber, this.props.version);
    }
  }

  componentDidUpdate(prevProps: ReadyForCarriageCheckContainerProps) {

    const doNumber: string = this.props.doNumber;
    const awbCode: string = this.props.code;
    const awbNumber: string = this.props.number;

    if (prevProps.doNumber !== doNumber && prevProps.number !== awbNumber) {
      
      this.setState({ doNumber, awbCode, awbNumber });
      this.handleCommonResponsePoAwb(doNumber, awbCode, awbNumber, this.props.version);
    }
  }

  handleCommonResponsePoAwb = (poNumber: string, awbCode: string, awbNumber: string, ver: number): void => {

    pickupOrderRemote.getGhaPoAwb(poNumber, awbCode, awbNumber, ver).then((resp: ApiResponse<GhaPickupStatus>) => {

      const status: GhaPickupStatus | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (status) {
        let staus = false;
        const poAwb: GhaPickupStatusAwb = status.po_awb;
        const statusTransportation: boolean  = status.valid_transportation ? status.valid_transportation : false;
        const statusShipper: boolean = status.valid_shipper_profile ? status.valid_shipper_profile : false;
        if(status.flight && status.flight.substring(0,2).toUpperCase() === 'PO' && !poAwb.isInterline) {
          poAwb.shipper_profile = 'Unknown';
        }
        if(poAwb.special_form_data) {
          let status = false;
          poAwb.special_form_data.specials_form_data.forEach(val => {
            if(val.value) {
              status = true;
            }
          });
          if(poAwb.special_form_data.other.name.length) {
            status = true
          }
          this.setSpecialStatus(status);
        }
        this.setState({ poAwb, statusOther: poAwb.r4c_form_green, flight: status.flight, deliveredDate: status.delivered_date, statusTransportation, statusShipper });
      }

      if (error) {
        this.props.receiveError(error);
      }
    });
  }

  
  
  setContainerState = ( poAwb: GhaPickupStatusAwb, statusTransportation: boolean, statusShipper: boolean): void => {
    this.setState({poAwb, statusTransportation, statusShipper });
  }

  setStatusOther = (statusOther: boolean): void => {
    this.setState({ statusOther })
  }

  setSpecialStatus = (specialstatus: boolean): void => {
    this.setState({ specialstatus })
  }

  setStatusInterline = (statusInterline: boolean): void => {
    this.setState({ statusInterline })
  }

  setStatePoAwb = (poAwb: GhaPickupStatusAwb): void => {
    this.setState({ poAwb });
  }
  
  render() {

    return (
      <ReadyForCarriageCheck
        poAwb={ this.state.poAwb }
        flight={ this.state.flight }
        awbCode={ this.state.awbCode }
        awbNumber={ this.state.awbNumber }
        handleClose={ this.props.handleClose }
        doNumber={ this.state.doNumber }
        statusTransportation={ this.state.statusTransportation }
        statusShipper={ this.state.statusShipper }
        statusOther={ this.state.statusOther }
        setContainerState={ this.setContainerState }
        setStatePoAwb={ this.setStatePoAwb}
        setStatusOther={ this.setStatusOther }
        statusInterline={ this.state.statusInterline }
        setStatusIterline={ this.setStatusInterline }
        onlyRead={ this.props.onlyRead }
        deliveredDate={ this.state.deliveredDate }
        setSpecialStatus={ this.setSpecialStatus }
        specialStatus={ this.state.specialstatus }
        awbVersion={ this.props.version }
      />
    );
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error))
  };
}

export default connect(null, mapDispatchToProps)(ReadyForCarriageCheckContainer);